var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "227px",
    viewBox: "0 0 256 227",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M159.032004,16.2735642 C149.604559,1.90793512 147.35993,0 128.168347,0 L128.168347,0 L127.943884,0 L127.719421,0 L127.719421,0 C108.527839,0 106.395441,1.90793512 96.855765,16.2735642 C87.9894783,29.7413415 0,190.905743 0,195.395002 C0,201.904428 1.68347216,208.077159 7.74397194,216.831214 C13.9167032,225.697501 24.5786936,230.635686 32.3226655,222.779483 C37.5975449,217.504603 94.0499781,120.199912 121.322227,83.3879877 L121.322227,83.3879877 C124.57694,78.7864972 131.310829,78.7864972 134.677773,83.3879877 L134.677773,83.3879877 C161.950022,120.199912 218.402455,217.504603 223.677335,222.779483 C231.421306,230.635686 242.083297,225.697501 248.256028,216.831214 C254.316528,208.077159 256,201.904428 256,195.395002 C255.887769,190.905743 167.89829,29.62911 159.032004,16.2735642 Z",
    fill: "#1173B6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpo);
export default __webpack_public_path__ + "static/media/expo.8230c001d0d507aa5e22eac60c0b2d38.svg";
export { ForwardRef as ReactComponent };